import { SortParams } from '../../../typings/grid';

export const SORT_INTERNAL_PRODUCTS = 'SORT_INTERNAL_PRODUCTS';
export type SORT_INTERNAL_PRODUCTS = typeof SORT_INTERNAL_PRODUCTS;

export interface SortInternalProducts {
    type: SORT_INTERNAL_PRODUCTS;
    sortParams: SortParams;
}

export function sortInternalProductsAction(sortParams: SortParams): SortInternalProducts {
    return {
        type: SORT_INTERNAL_PRODUCTS,
        sortParams
    };
}
